import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { Box, Link, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { Link as RouterLink, useParams } from 'react-router-dom';

import { INSTANCE_STATE } from '../../../apis/constants';
import { buildPath, PRIVATE_ROUTE } from '../../../routes/routes';
import { isGPSInstance, isSolrInstance } from '../../../utils/utils';
import CopyableText from '../../elements/copyable-text/CopyableText';
import Text from '../../elements/text/Text';

const CidrDetails = ({ isAdmin, instance, solrUrl }) => {
  const { t } = useTranslation();
  const { projectId, instanceId, gpsId } = useParams();

  const isPrivate = instance.cidrs.length < 1;
  const isBusy = instance.status === INSTANCE_STATE.PENDING;

  return (
    <Box sx={{ mb: 4 }}>
      {isPrivate ? (
        isAdmin ? (
          <Text caption>
            {(isSolrInstance(instance.clusterType) ||
              isGPSInstance(instance.clusterType)) && (
              <Trans
                i18nKey="setCidrBeforeUrlAccess"
                ns="descriptions"
                components={[
                  <Link
                    key="0"
                    component={RouterLink}
                    to={buildPath({
                      path: isSolrInstance(instance.clusterType)
                        ? PRIVATE_ROUTE.INSTANCE_SETTINGS
                        : PRIVATE_ROUTE.GPS_SETTINGS,
                      params: isSolrInstance(instance.clusterType)
                        ? { projectId: projectId, instanceId: instanceId }
                        : { projectId: projectId, gpsId: gpsId },
                    })}
                    underline="hover"
                  />,
                ]}
              />
            )}
          </Text>
        ) : (
          <Text caption>{t('cidrConfigRequired', { ns: 'descriptions' })}</Text>
        )
      ) : (
        <Box sx={{ display: 'inline-block' }}>
          <CopyableText
            id="solr-url"
            label={t('subdomainUrl', { ns: 'instance' })}
            text={solrUrl}
          />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Text id="cidr-list" caption color="textSecondary">
              {t('accessibleFrom', {
                ns: 'instance',
                text: instance.cidrs.map((cidr) => cidr.cidr).join(', '),
              })}
            </Text>
            {isBusy && (
              <Tooltip
                arrow
                title={t('instanceUpdate', { ns: 'descriptions' })}
              >
                <WarningRoundedIcon
                  color="warning"
                  sx={{ marginLeft: 0.5 }}
                  fontSize="small"
                />
              </Tooltip>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

CidrDetails.propTypes = {
  instance: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool,
  solrUrl: PropTypes.string,
};

export default CidrDetails;
